// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_na-0";